import { CanvasPreviewDeviceTarget, CanvasPreviewTarget } from './types';

const predefinedPreviewDeviceTargets = {
  Mobile: {
    name: 'Mobile',
    width: '375px',
    group: 'iPhone',
    systemVars: {
      dimensions: {
        screen: {
          width: 375,
          height: 812,
        },
        viewport: {
          width: 375,
          height: 812,
        },
        window: {
          width: 375,
          height: 812,
        },
      },
      formFactor: 'phone',
      os: 'ios',
      runtime: 'native',
      orientation: 'portrait',
      browser: null,
    },
  },
  Tablet: {
    name: 'Tablet',
    width: '834px',
    group: 'iPad',
    systemVars: {
      dimensions: {
        screen: {
          width: 834,
          height: 1194,
        },
        viewport: {
          width: 834,
          height: 1194,
        },
        window: {
          width: 834,
          height: 1194,
        },
      },
      formFactor: 'tablet',
      os: 'ios',
      runtime: 'native',
      orientation: 'portrait',
      browser: null,
    },
  },
} satisfies Record<string, CanvasPreviewDeviceTarget>;

const predefinedPreviewTargets = {
  ...predefinedPreviewDeviceTargets,
  Fullscreen: {
    name: 'Fullscreen',
    width: '100%',
    group: 'Web',
    systemVars: {}, // Use defaults
  },
} satisfies Record<string, CanvasPreviewTarget>;

export type PredefinedCanvasPreviewTargetName = keyof typeof predefinedPreviewTargets;
export type PredefinedCanvasPreviewTargetDeviceName = keyof typeof predefinedPreviewDeviceTargets;

export default predefinedPreviewTargets;
